module.exports = __webpack_public_path__ + "static/media/c35.3f31da76.png";